import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=70621100&"
import script from "./dialog.component?vue&type=script&lang=ts&"
export * from "./dialog.component?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports